import { inject, Injectable } from '@angular/core';
import { MessageService } from '@openng/optimus-ui/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _messageService = inject(MessageService);

  showMessage(
    severity: 'success' | 'info' | 'warn' | 'error',
    summary: string,
    detail?: string
  ): void {
    this._messageService.add({ severity, summary, detail, life: 5000 });
  }

  showSuccess(message: string): void {
    this._messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 4000,
    });
  }

  showError(message: string): void {
    this._messageService.add({ severity: 'error', summary: 'Error', detail: message, life: 6000 });
  }

  showInfo(message: string): void {
    this._messageService.add({ severity: 'info', summary: 'Info', detail: message, life: 4000 });
  }

  showWarning(message: string): void {
    this._messageService.add({ severity: 'warn', summary: 'Warning', detail: message, life: 5000 });
  }
}
